import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Component, OnInit, Injector } from '@angular/core';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-callback-modal',
  templateUrl: './callback-modal.component.html',
  styleUrls: ['./callback-modal.component.css']
})
export class CallbackModalComponent  extends ModalBaseComponent {

  message: string;
  operationName: string;
  callback: () => any;

  constructor(inject: Injector,private _bsModalRef: BsModalRef) {
    super(inject);
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }

  // do it
  public execute(){
    this.callback();
    this._bsModalRef.hide();
  }



}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/callback-modal/callback-modal.component.ts